export default __webpack_public_path__ + "static/media/gallery_04.fdf01c16.jpg";